
const wstPayMainRoutes = Array.from({ length: 13 }, (_, i) => ({
  path: `pay/wst/index${i + 1}`,
  name: `payWstIndex${i + 1}`,
  component: () => import(`@/views/health/pay/wst/index${i + 1}.vue`),
}));


export default {
  path: "/health",
  component: { render: (c) => c("router-view") },
  children: [
    // 预约挂号——皖事通，主流程
    ...wstPayMainRoutes,
  ],
};
